import * as postProcess from "post-processes/legacy/legacy";
export { postProcess };
export default postProcess;
